import React from "react";
import { useNavigate } from "react-router-dom";
import { Inbox, AlertTriangle } from "lucide-react";

const FLAG_LABELS = {
  status_change_blocked: "In country as visitor",
  luanda_prior_authorization: "Luanda prior authorization",
  regulated_profession: "Regulated profession",
  has_previous_refusal: "Previous refusal",
  has_irregular_stay: "Irregular stay",
  applicant_is_minor: "Minor applicant",
  reunification_wait_applies: "2-year reunification rule",
  needs_translation: "Needs translation",
  needs_legalization: "Needs legalization",
  cplp_national: "CPLP national",
  inside_canada: "Inside Canada",
  inside_portugal: "Inside Portugal",
};

/** Shown on cases that came from a website form: reference, case type, flags, link to the full application. */
export const WebApplicationBanner = ({ details }) => {
  const navigate = useNavigate();
  if (!details || details.source !== "web_application") return null;
  const flags = Object.keys(details.flags || {}).filter((k) => FLAG_LABELS[k]);
  return (
    <div className="rounded-2xl border border-venka-blue/30 bg-venka-blue/10 p-4 flex flex-wrap items-center gap-3" data-testid="web-application-banner">
      <Inbox className="h-5 w-5 text-venka-green-light" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold">
          Website application <span className="font-mono">{details.reference}</span>
          <span className="ml-2 font-mono text-xs text-slate-400">{details.case_type}</span>
        </p>
        {flags.length > 0 && (
          <div className="mt-1.5 flex flex-wrap gap-1.5">
            {flags.map((f) => (
              <span key={f} className="inline-flex items-center gap-1 rounded-full bg-amber-500/15 px-2 py-0.5 text-[11px] font-semibold text-amber-300">
                <AlertTriangle className="h-3 w-3" /> {FLAG_LABELS[f]}
              </span>
            ))}
          </div>
        )}
      </div>
      {details.application_id && (
        <button type="button" onClick={() => navigate(`/portal/applications/${details.application_id}`)}
          className="rounded-md border border-white/15 px-3 py-1.5 text-sm hover:bg-white/10">
          Open full application
        </button>
      )}
    </div>
  );
};

export default WebApplicationBanner;
